export * from "./border";
export * from "./color";
export * from "./dialog";
export * from "./dimension";
export * from "./layout";
export * from "./shadow";
export * from "./spacing";
export * from "./transition";
export * from "./typography";
export * from "./unit";

export const zIndex = {
  base: 0,
  dropdown: 1100,
  sticky: 1200,
  window: 1250,
  modal: 1300,
  popover: 1400,
  tooltip: 1500,
  toast: 1600,
} as const;
